import { type FC, type PropsWithChildren, useCallback } from 'react'
import { type AxiosError, type AxiosResponse } from 'axios'
import { useResponseInterceptor } from '@dhl/axios'
import { useAuthenticationContext } from '../model/context.js'

export const AxiosErrorHandler: FC<PropsWithChildren> = ({ children }) => {
  const { setUnauthorized } = useAuthenticationContext()

  const onFulfilled = (response: AxiosResponse) => response
  const onRejected = useCallback(
    (error: AxiosError) =>
      new Promise((_, reject) => {
        const status = error?.response?.status

        if (status === 401 || status === 403) {
          if (error.request?.responseURL?.endsWith('/logout')) {
            // If logout fails, we want the original caller to handle the error
            reject(error)
          } else {
            setUnauthorized()
          }
        } else {
          reject(error)
        }
      }),
    [setUnauthorized]
  )

  useResponseInterceptor(onFulfilled, onRejected)

  return children
}
